// List of top colleges for selection
// In a real app, this might come from an API or a more extensive database

export const topColleges = [
  // Ivies
  'Harvard', 'Yale', 'Princeton', 'UPenn', 'Columbia', 'Brown', 'Dartmouth', 'Cornell',
  // Other Top Tier
  'Stanford', 'MIT', 'Caltech', 'UChicago', 'Northwestern', 'Duke', 'Johns Hopkins', 'Vanderbilt',
  // Top Publics / Others
  'UC Berkeley', 'UCLA', 'UMichigan', 'UVA', 'UNC Chapel Hill', 'Georgia Tech', 'NYU', 'CMU',
  // ADDED: New Colleges
  'USC', 'WashU', 'Rice', 'Notre Dame', 'Northeastern', 'Georgetown'
  // Add more as needed
];

// New cycle order: Rejected -> Accepted -> Waitlisted -> Committed -> Applied -> Deselect
export const applicationStatuses = [
    'Rejected',
    'Accepted',
    'Waitlisted',
    'Committed'
];

export const statusColors = {
    Applied: 'var(--status-applied, #adb5bd)',          // Gray (use CSS var or fallback)
    Accepted: 'var(--status-accepted, #28a745)',         // Green
    Rejected: 'var(--status-rejected, #dc3545)',         // Red
    Waitlisted: 'var(--status-waitlisted, #ffc107)',     // Yellow
    Committed: 'var(--button-primary-bg, #4a90e2)'      // Blue/Primary (use CSS var or fallback)
}; 